module.exports = __webpack_public_path__ + "static/img/iconmenu03_white.d650178a.svg";